/* Hof Elfental: Video/Karte erst nach Klick laden */
if (!window.heVideoInit) {
  window.heVideoInit = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-he-embed]');
    if (!b) return;
    var box = b.parentElement;
    var f = document.createElement('iframe');
    f.src = b.getAttribute('data-he-embed');
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    f.allowFullscreen = true;
    f.title = b.getAttribute('data-he-title') || '';
    box.innerHTML = '';
    box.appendChild(f);
  });
}

/* Nachtrag 15.10.: Google-Karte automatisch laden, sobald Besucher dem Cookie-Banner zugestimmt haben.
   Der Shop nutzt die App "Booster EU Cookie" (cookieconsent), die ihre Zustimmung NICHT an Shopify meldet.
   Deshalb zaehlt das Cookie "cookieconsent_status" (allow/dismiss). Ist stattdessen Shopifys eigener
   Banner aktiv, wird dessen Zustimmung (Praeferenzen/Marketing) genutzt. Ohne Zustimmung bleibt der Button "Karte laden". */
(function () {
  function ccStatus() {
    var m = document.cookie.match(/(?:^|;\s*)cookieconsent_status=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function allowed() {
    var s = ccStatus();
    if (s === 'allow' || s === 'dismiss') return true;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    try {
      if (cp && cp.shouldShowBanner && cp.shouldShowBanner()) return cp.preferencesProcessingAllowed() || cp.marketingAllowed();
    } catch (e) {}
    return false;
  }
  function loadMaps() {
    document.querySelectorAll('.he-map [data-he-embed]').forEach(function (b) { b.click(); });
  }
  function check() { if (allowed()) loadMaps(); }
  function init() {
    if (!document.querySelector('.he-map')) return;
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) check(); });
    } else { check(); }
    document.addEventListener('visitorConsentCollected', check);
    document.addEventListener('click', function (e) {
      if (e.target.closest('.cc-btn, .cc-allow, .cc-dismiss')) setTimeout(check, 300);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
